import React, { useState, useEffect } from "react";

import AuthUser from "../../services/AuthUser";
import { useNavigate } from "react-router-dom";




const FileUploadModal = () => {
  const [files, setFiles] = useState([]);
  const [name, setName] = useState(""); // Store user name
  const [email, setEmail] = useState(""); // Store user email
  const [error, setError] = useState("");
           const { http, token } = AuthUser();
   const navigate = useNavigate();

      useEffect(() => {
        const agent = JSON.parse(localStorage.getItem("agent"));
        const user = JSON.parse(localStorage.getItem("user"));
      
        if (agent && agent.email) {
          console.log("Logged in as Agent:", agent);
          setEmail(agent.email);
          setName(agent.user_id || "Agent");
          // You can also set a flag: setIsAgent(true);
        } else if (user && user.email) {
          console.log("Logged in as User:", user);
          setEmail(user.email);
          setName(user.user_id || "User");
          // setIsAgent(false);
        } else {
          setError("User not found.");
        }
      }, []);
      

  const handleFileChange = (e) => {
    setFiles(Array.from(e.target.files)); // Ensures compatibility
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!name || !email || files.length === 0) {
      alert("Please fill all fields and select files.");
      return;
    }
  
    const formData = new FormData();
    formData.append("doc_id", name);
    formData.append("email", email);
    files.forEach((file) => {
      formData.append("documents[]", file); // Array format
    });
  
    try {
      const response = await http.post("/upload-files", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      alert(response.data.message);
      setFiles([]); // Reset files
    } catch (error) {
      alert("File upload failed! Please try again.");
      console.error(error);
    }
  };


  return (
    <div className="container">
  

      {/* Modal */}
      <div className="modal fade" id="uploadModal" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Upload Documents</h5>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              >
                
              </button>

              {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> */}
            </div>

            <div className="modal-body">
            {error && <div className="alert alert-danger">{error}</div>}
              <form onSubmit={handleSubmit}>
                {/* Name Field */}
          

                {/* Email Field */}
            

                {/* File Input */}
                <div className="form-group">
                  <label>Upload Documents</label>
                  <input
                    type="file"
                    className="form-control-file"
                    multiple
                    onChange={handleFileChange}
                    required
                  />
                </div>

                {/* Selected Files List */}
                {files.length > 0 && (
                  <div className="mt-3">
                    <h6>Selected Files:</h6>
                    <ul className="list-group">
                      {files.map((file, index) => (
                        <li key={index} className="list-group-item">
                          {file.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Submit Button */}
                <div className="modal-footer">
                  <button type="submit" className="btn btn-success">
                    Upload
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileUploadModal;
